module.exports = __webpack_public_path__ + "static/media/recovery.2bc335b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/recovery.svg
// module id = 125
// module chunks = 0